import { render, staticRenderFns } from "./equipmentJY.vue?vue&type=template&id=332a8004&scoped=true"
import script from "./equipmentJY.vue?vue&type=script&lang=js"
export * from "./equipmentJY.vue?vue&type=script&lang=js"
import style0 from "./equipmentJY.vue?vue&type=style&index=0&id=332a8004&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a8004",
  null
  
)

export default component.exports